document.addEventListener('click', (event) => {
  const tab = event.target.closest('[data-pvn-tab]');
  if (tab) {
    const root = tab.closest('[data-pvn-tabs]');
    if (!root) return;
    root.querySelectorAll('[data-pvn-tab]').forEach((button) => button.setAttribute('aria-selected', 'false'));
    root.querySelectorAll('[data-pvn-panel]').forEach((panel) => panel.classList.remove('is-active'));
    tab.setAttribute('aria-selected', 'true');
    root.querySelector(`[data-pvn-panel="${tab.dataset.pvnTab}"]`)?.classList.add('is-active');
  }

  const thumb = event.target.closest('[data-pvn-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-pvn-gallery]');
    const image = gallery?.querySelector('[data-pvn-main-image], .pvn-pdp-gallery__main img');
    if (!gallery || !image) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = thumb.dataset.pvnThumb;
    gallery.querySelectorAll('[data-pvn-thumb]').forEach((button) => button.setAttribute('aria-current', 'false'));
    thumb.setAttribute('aria-current', 'true');

    const tryonImg = gallery?.querySelector('[data-pvn-tryon-img]');
    if (tryonImg) {
      const tryonUrl = thumb.dataset.pvnTryon;
      if (tryonUrl) {
        tryonImg.src = tryonUrl;
        tryonImg.hidden = false;
      } else {
        tryonImg.hidden = true;
      }
    }
  }

  const wish = event.target.closest('[data-pvn-wishlist]');
  if (wish) {
    event.preventDefault();
    wish.classList.toggle('is-active');
  }

  const filterDrawerOpen = event.target.closest('[data-pvn-filter-drawer-open]');
  if (filterDrawerOpen) {
    event.preventDefault();
    openPvnCollectionDrawer(filterDrawerOpen.closest('[data-pvn-collection-filters]'));
    return;
  }

  const filterDrawerClose = event.target.closest('[data-pvn-filter-drawer-close]');
  if (filterDrawerClose) {
    event.preventDefault();
    closePvnCollectionDrawer(filterDrawerClose.closest('[data-pvn-collection-filters]'));
    return;
  }

  const filterOption = event.target.closest('[data-pvn-filter-option]');
  if (filterOption) {
    event.preventDefault();
    const root = filterOption.closest('[data-pvn-collection-filters]');
    if (!root) return;

    if (filterOption.dataset.filterGroup === 'price') {
      root.querySelectorAll('[data-pvn-filter-option][data-filter-group="price"]').forEach((button) => {
        button.setAttribute('aria-pressed', button === filterOption ? 'true' : 'false');
      });
    } else {
      const isPressed = filterOption.getAttribute('aria-pressed') === 'true';
      filterOption.setAttribute('aria-pressed', isPressed ? 'false' : 'true');
    }

    applyPvnCollectionFilters(root);
  }

  const filterClear = event.target.closest('[data-pvn-filter-clear]');
  if (filterClear) {
    event.preventDefault();
    const root = filterClear.closest('[data-pvn-collection-filters]');
    if (!root) return;
    root.querySelectorAll('[data-pvn-filter-option]').forEach((button) => {
      const isAnyPrice = button.dataset.filterGroup === 'price' && button.dataset.filterValue === 'any';
      button.setAttribute('aria-pressed', isAnyPrice ? 'true' : 'false');
    });
    applyPvnCollectionFilters(root);
  }

  const filterCollapse = event.target.closest('[data-pvn-filter-collapse]');
  if (filterCollapse) {
    const group = filterCollapse.closest('.pvn-filter-group');
    if (!group) return;
    const isCollapsed = group.classList.toggle('is-collapsed');
    filterCollapse.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
    const indicator = filterCollapse.querySelector('[aria-hidden="true"]');
    if (indicator) indicator.textContent = isCollapsed ? '+' : '-';
  }

  const qtyButton = event.target.closest('[data-pvn-qty]');
  if (qtyButton) {
    const wrapper = qtyButton.closest('.pvn-qty');
    const input = wrapper?.querySelector('input');
    if (!input) return;
    const step = qtyButton.dataset.pvnQty === 'inc' ? 1 : -1;
    input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const optionButton = event.target.closest('[data-pvn-option-button]');
  if (optionButton) {
    const form = optionButton.closest('[data-pvn-product-form]');
    if (!form) return;
    const position = optionButton.dataset.optionPosition;
    const value = optionButton.dataset.optionValue;
    form.querySelectorAll(`[data-pvn-option-button][data-option-position="${position}"]`).forEach((button) => {
      const isActive = button === optionButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });
    form.dataset[`option${position}`] = value;
    const selectedLabel = form.querySelector(`[data-pvn-option-selected="${position}"]`);
    if (selectedLabel) selectedLabel.textContent = value;
    updateSelectedPvnVariant(form);
  }
});

document.addEventListener('change', (event) => {
  const variantSelect = event.target.closest('[data-pvn-variant-select]');
  if (!variantSelect) return;
  const form = variantSelect.closest('form');
  const idInput = form?.querySelector('input[name="id"]');
  if (idInput) idInput.value = variantSelect.value;
});

function updateSelectedPvnVariant(form) {
  const variantsEl = form.querySelector('[data-pvn-variants-json]');
  const idInput = form.querySelector('input[name="id"]');
  if (!variantsEl || !idInput) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsEl.textContent);
  } catch (_error) {
    return;
  }

  const selected = [
    form.dataset.option1,
    form.dataset.option2,
    form.dataset.option3,
  ].filter(Boolean);

  const variant = variants.find((item) => {
    return selected.every((value, index) => item.options[index] === value);
  });

  if (!variant) return;

  idInput.value = variant.id;

  if (variant.featured_image && variant.featured_image.src) {
    const gallery = form.closest('.pvn-pdp')?.querySelector('[data-pvn-gallery]') || document.querySelector('[data-pvn-gallery]');
    const mainImage = gallery?.querySelector('[data-pvn-main-image], .pvn-pdp-gallery__main img');
    if (mainImage) {
      let imageSrc = variant.featured_image.src;
      try {
        const imageUrl = new URL(imageSrc, window.location.origin);
        imageUrl.searchParams.set('width', '1100');
        imageSrc = imageUrl.toString();
      } catch (_error) {
        // keep the original src if it cannot be parsed
      }
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = imageSrc;
    }
    const variantImagePath = variant.featured_image.src.split('?')[0];
    gallery?.querySelectorAll('[data-pvn-thumb]').forEach((button) => {
      const thumbPath = (button.dataset.pvnThumb || '').split('?')[0];
      button.setAttribute('aria-current', thumbPath === variantImagePath ? 'true' : 'false');
    });
  }

  const variantSelect = form.querySelector('[data-pvn-variant-select]');
  if (variantSelect) variantSelect.value = String(variant.id);

  const addButton = form.querySelector('[data-pvn-add-button]');
  if (addButton) {
    addButton.disabled = !variant.available;
    const price = window.Shopify?.formatMoney
      ? window.Shopify.formatMoney(variant.price, window.theme?.moneyFormat || '{{amount}}')
      : new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(variant.price / 100);
    addButton.textContent = variant.available ? `Add to Bag · ${price}` : 'Sold out';
  }

  const priceEl = document.querySelector('[data-pvn-product-price]');
  if (priceEl) {
    priceEl.textContent = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(variant.price / 100);
  }

  const compareEl = document.querySelector('[data-pvn-compare-price]');
  if (compareEl) {
    compareEl.textContent = variant.compare_at_price
      ? new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(variant.compare_at_price / 100)
      : '';
    compareEl.hidden = !variant.compare_at_price;
  }
}

const pvnCollectionDrawerMediaQuery = window.matchMedia('(max-width: 989px)');

function getActivePvnFilterCount(root) {
  return Array.from(root.querySelectorAll('[data-pvn-filter-option][aria-pressed="true"]')).reduce((count, button) => {
    if (button.dataset.filterGroup === 'price' && button.dataset.filterValue === 'any') {
      return count;
    }

    return count + 1;
  }, 0);
}

function updatePvnCollectionFilterToggle(root) {
  const toggle = root.querySelector('[data-pvn-filter-drawer-open]');
  const badge = root.querySelector('[data-pvn-filter-active-count]');
  if (!toggle || !badge) return;

  const activeCount = getActivePvnFilterCount(root);
  badge.hidden = activeCount === 0;
  badge.textContent = String(activeCount);
  toggle.classList.toggle('has-active-filters', activeCount > 0);
  toggle.setAttribute('aria-label', activeCount > 0 ? `Open filters, ${activeCount} active` : 'Open filters');
}

function syncPvnCollectionDrawerState(root) {
  const filterRail = root.querySelector('[data-pvn-filter-rail]');
  const toggle = root.querySelector('[data-pvn-filter-drawer-open]');
  if (!filterRail || !toggle) return;

  if (!pvnCollectionDrawerMediaQuery.matches) {
    root.classList.remove('is-pvn-filter-drawer-open');
  }

  const isOpen = pvnCollectionDrawerMediaQuery.matches && root.classList.contains('is-pvn-filter-drawer-open');
  toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

  if (pvnCollectionDrawerMediaQuery.matches) {
    filterRail.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if ('inert' in filterRail) filterRail.inert = !isOpen;
  } else {
    filterRail.removeAttribute('aria-hidden');
    if ('inert' in filterRail) filterRail.inert = false;
  }

  const isAnyDrawerOpen = Boolean(document.querySelector('[data-pvn-collection-filters].is-pvn-filter-drawer-open'));
  document.documentElement.classList.toggle('pvn-filter-drawer-open', isAnyDrawerOpen);
  document.body.classList.toggle('pvn-filter-drawer-open', isAnyDrawerOpen);
}

function openPvnCollectionDrawer(root) {
  if (!root || !pvnCollectionDrawerMediaQuery.matches) return;

  root.classList.add('is-pvn-filter-drawer-open');
  syncPvnCollectionDrawerState(root);
  root.querySelector('[data-pvn-filter-drawer-close-button]')?.focus();
}

function closePvnCollectionDrawer(root, { returnFocus = true } = {}) {
  if (!root) return;

  root.classList.remove('is-pvn-filter-drawer-open');
  syncPvnCollectionDrawerState(root);

  if (returnFocus && pvnCollectionDrawerMediaQuery.matches) {
    root.querySelector('[data-pvn-filter-drawer-open]')?.focus();
  }
}

function applyPvnCollectionFilters(root) {
  const selected = {
    category: getPvnSelectedFilterValues(root, 'category'),
    color: getPvnSelectedFilterValues(root, 'color'),
    size: getPvnSelectedFilterValues(root, 'size'),
  };
  const selectedPrice = root.querySelector('[data-pvn-filter-option][data-filter-group="price"][aria-pressed="true"]');
  const cards = Array.from(root.querySelectorAll('[data-pvn-filter-card]'));
  let visibleCount = 0;

  cards.forEach((card) => {
    const price = Number(card.dataset.pvnPrice || 0);
    const matchesCategory = !selected.category.length || selected.category.includes(card.dataset.pvnCategory);
    const matchesColor = !selected.color.length || selected.color.some((value) => (card.dataset.pvnColors || '').includes(`|${value}|`));
    const matchesSize = !selected.size.length || selected.size.some((value) => (card.dataset.pvnSizes || '').includes(`|${value}|`));
    const matchesPrice = !selectedPrice || selectedPrice.dataset.filterValue === 'any' || (
      (!selectedPrice.dataset.priceMin || price >= Number(selectedPrice.dataset.priceMin)) &&
      (!selectedPrice.dataset.priceMax || price <= Number(selectedPrice.dataset.priceMax))
    );
    const isVisible = matchesCategory && matchesColor && matchesSize && matchesPrice;

    card.hidden = !isVisible;
    card.classList.toggle('is-filtered-out', !isVisible);
    if (isVisible) visibleCount += 1;
  });

  const countText = `${visibleCount} ${visibleCount === 1 ? 'product' : 'products'}`;
  root.querySelectorAll('.products-count-wrapper [role="status"], [data-pvn-filter-count]').forEach((count) => {
    count.textContent = countText;
  });

  root.classList.toggle('has-active-pvn-filters', hasActivePvnCollectionFilters(root));
  root.classList.toggle('has-empty-pvn-results', visibleCount === 0);
  updatePvnCollectionFilterToggle(root);
}

function getPvnSelectedFilterValues(root, group) {
  return Array.from(root.querySelectorAll(`[data-pvn-filter-option][data-filter-group="${group}"][aria-pressed="true"]`))
    .map((button) => button.dataset.filterValue)
    .filter(Boolean);
}

function hasActivePvnCollectionFilters(root) {
  return Array.from(root.querySelectorAll('[data-pvn-filter-option][aria-pressed="true"]')).some((button) => {
    return button.dataset.filterGroup !== 'price' || button.dataset.filterValue !== 'any';
  });
}

const PVN_SWIPER_LIBRARY_URL = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
const pvnSliderInstances = new Map();

let pvnSwiperLibraryPromise = null;
let pvnSliderMutationObserver = null;
let pvnSliderRefreshFrame = 0;
let pvnSliderSyncToken = 0;

function loadPvnSwiperLibrary() {
  if (window.Swiper) return Promise.resolve(window.Swiper);
  if (pvnSwiperLibraryPromise) return pvnSwiperLibraryPromise;

  pvnSwiperLibraryPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector('script[data-pvn-swiper-library]');

    if (existingScript && window.Swiper) {
      resolve(window.Swiper);
      return;
    }

    const handleLoad = () => {
      if (window.Swiper) {
        resolve(window.Swiper);
      } else {
        reject(new Error('Swiper failed to initialize.'));
      }
    };

    const handleError = () => reject(new Error('Failed to load Swiper library.'));

    if (existingScript) {
      existingScript.addEventListener('load', handleLoad, { once: true });
      existingScript.addEventListener('error', handleError, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = PVN_SWIPER_LIBRARY_URL;
    script.defer = true;
    script.dataset.pvnSwiperLibrary = 'true';
    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', handleError, { once: true });
    document.head.append(script);
  }).catch((error) => {
    console.error('PVN slider error:', error);
    pvnSwiperLibraryPromise = null;
    return null;
  });

  return pvnSwiperLibraryPromise;
}

function getPvnSliderSlideCount(root) {
  return root.querySelectorAll('.pvn-slider__slide').length;
}

function getPvnSliderEdgeOffset(root) {
  const container = root.closest('.pvn-container');
  if (!container) return 0;

  const containerStyle = window.getComputedStyle(container);
  return Number.parseFloat(containerStyle.paddingInlineStart || containerStyle.paddingLeft || '0') || 0;
}

function shouldEnablePvnSlider(root) {
  const disableAt = Number(root.dataset.pvnSliderDisableAt || 1024);
  return getPvnSliderSlideCount(root) > 1 && window.innerWidth < disableAt;
}

function resetPvnSliderControls(root) {
  root.querySelector('[data-pvn-slider-pagination]')?.replaceChildren();

  root.querySelectorAll('[data-pvn-slider-prev], [data-pvn-slider-next]').forEach((button) => {
    button.classList.remove('swiper-button-disabled');
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
  });
}

function updatePvnSliderStatus(root, swiper) {
  root.classList.toggle('is-at-start', swiper.isBeginning);
  root.classList.toggle('is-at-end', swiper.isEnd);
  root.classList.toggle('is-locked', swiper.isLocked);
}

function updatePvnSliderOffsets(root, swiper) {
  const edgeOffset = getPvnSliderEdgeOffset(root);
  swiper.params.slidesOffsetAfter = edgeOffset;
  swiper.originalParams.slidesOffsetAfter = edgeOffset;
}

function destroyPvnSlider(root) {
  const instance = pvnSliderInstances.get(root);
  if (instance) {
    instance.destroy(true, true);
    pvnSliderInstances.delete(root);
  }

  root.classList.remove('is-swiper-ready', 'is-at-start', 'is-at-end', 'is-locked');
  resetPvnSliderControls(root);
}

function getPvnSliderOptions(root) {
  const isReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sliderType = root.dataset.pvnSliderType;

  return {
    slidesPerView: 'auto',
    speed: isReducedMotion ? 0 : 520,
    grabCursor: true,
    watchOverflow: true,
    slidesOffsetAfter: getPvnSliderEdgeOffset(root),
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    spaceBetween: sliderType === 'testimonial' ? 18 : 14,
    breakpoints: sliderType === 'testimonial'
      ? {
          750: {
            spaceBetween: 20,
          },
        }
      : {
          768: {
            spaceBetween: 16,
          },
        },
    navigation: {
      prevEl: root.querySelector('[data-pvn-slider-prev]'),
      nextEl: root.querySelector('[data-pvn-slider-next]'),
    },
    pagination: {
      el: root.querySelector('[data-pvn-slider-pagination]'),
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 3,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideRole: 'group',
    },
    on: {
      afterInit(swiper) {
        root.classList.add('is-swiper-ready');
        updatePvnSliderOffsets(root, swiper);
        swiper.update();
        updatePvnSliderStatus(root, swiper);
      },
      lock(swiper) {
        updatePvnSliderStatus(root, swiper);
      },
      unlock(swiper) {
        updatePvnSliderStatus(root, swiper);
      },
      resize(swiper) {
        updatePvnSliderOffsets(root, swiper);
        swiper.update();
        updatePvnSliderStatus(root, swiper);
      },
      slideChange(swiper) {
        updatePvnSliderStatus(root, swiper);
      },
      update(swiper) {
        updatePvnSliderStatus(root, swiper);
      },
      destroy() {
        root.classList.remove('is-swiper-ready', 'is-at-start', 'is-at-end', 'is-locked');
        resetPvnSliderControls(root);
      },
    },
  };
}

async function syncPvnSliders() {
  const syncToken = ++pvnSliderSyncToken;
  const sliderRoots = Array.from(document.querySelectorAll('[data-pvn-slider]'));

  sliderRoots.forEach((root) => {
    root.classList.toggle('has-multiple-slides', getPvnSliderSlideCount(root) > 1);
  });

  for (const [root, instance] of pvnSliderInstances.entries()) {
    if (!document.body.contains(root) || !shouldEnablePvnSlider(root)) {
      destroyPvnSlider(root);
      continue;
    }

    const track = root.querySelector('.pvn-slider__track');
    if (track !== instance.wrapperEl) {
      destroyPvnSlider(root);
      continue;
    }

    updatePvnSliderOffsets(root, instance);
    instance.update();
    updatePvnSliderStatus(root, instance);
  }

  const rootsToInitialize = sliderRoots.filter((root) => {
    return shouldEnablePvnSlider(root) && !pvnSliderInstances.has(root);
  });

  if (!rootsToInitialize.length) return;

  const SwiperLibrary = await loadPvnSwiperLibrary();
  if (!SwiperLibrary || syncToken !== pvnSliderSyncToken) return;

  rootsToInitialize.forEach((root) => {
    if (!document.body.contains(root) || !shouldEnablePvnSlider(root) || pvnSliderInstances.has(root)) return;

    const instance = new SwiperLibrary(root, getPvnSliderOptions(root));
    pvnSliderInstances.set(root, instance);
  });
}

function schedulePvnSliderSync() {
  if (pvnSliderRefreshFrame) return;

  pvnSliderRefreshFrame = window.requestAnimationFrame(() => {
    pvnSliderRefreshFrame = 0;
    syncPvnSliders();
  });
}

function observePvnSliderChanges() {
  if (pvnSliderMutationObserver || !document.body) return;

  pvnSliderMutationObserver = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) {
      schedulePvnSliderSync();
    }
  });

  pvnSliderMutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// Scroll-reveal animations
document.addEventListener('DOMContentLoaded', () => {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('[data-reveal]').forEach((el) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    revealObserver.observe(el);
  });

  document.querySelectorAll('[data-reveal].is-revealed').forEach((el) => {
    el.style.opacity = '1';
    el.style.transform = 'translateY(0)';
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pvn-collection-filters]').forEach((root) => {
    applyPvnCollectionFilters(root);
    syncPvnCollectionDrawerState(root);
  });

  schedulePvnSliderSync();
  observePvnSliderChanges();
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  const root = document.querySelector('[data-pvn-collection-filters].is-pvn-filter-drawer-open');
  if (!root) return;

  closePvnCollectionDrawer(root);
});

if (typeof pvnCollectionDrawerMediaQuery.addEventListener === 'function') {
  pvnCollectionDrawerMediaQuery.addEventListener('change', () => {
    document.querySelectorAll('[data-pvn-collection-filters]').forEach((root) => syncPvnCollectionDrawerState(root));
  });
}

window.addEventListener('resize', schedulePvnSliderSync, { passive: true });

// Sticky / fixed header behavior on scroll
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.pvn-site-header, header-component');
  if (!header) return;

  const isFixed = header.classList.contains('pvn-site-header--fixed');

  // A fixed header is out of flow, so reserve its height with a spacer.
  if (isFixed) {
    const spacer = document.createElement('div');
    spacer.className = 'pvn-header-spacer';
    spacer.style.display = 'block';
    const setSpacerHeight = () => {
      spacer.style.height = header.offsetHeight + 'px';
    };
    setSpacerHeight();
    header.parentNode.insertBefore(spacer, header.nextSibling);
    window.addEventListener('resize', setSpacerHeight, { passive: true });
  }

  let ticking = false;
  let lastScrollY = window.scrollY;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const currentY = window.scrollY;
        header.classList.toggle('is-scrolled', currentY > 10);

        // Fixed: hide when scrolling down, reveal when scrolling up.
        if (isFixed) {
          const scrollingDown = currentY > lastScrollY;
          header.classList.toggle('is-hidden', scrollingDown && currentY > header.offsetHeight);
        }

        lastScrollY = currentY;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
});

// Back to top button: reveal after scrolling, smooth-scroll to top on click.
(function setupBackToTop() {
  const button = document.querySelector('[data-pvn-back-to-top]');
  if (!button) return;

  button.hidden = false;

  const threshold = 300;
  let ticking = false;

  const update = () => {
    button.classList.toggle('is-visible', window.scrollY > threshold);
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  button.addEventListener('click', () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  update();
})();
